import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { type VersionResponse } from './models/versionResponse';
import { useHttpClient } from '@/common/api/httpClient';
import { storeToRefs } from 'pinia';

export interface GetVersionResponse {
  ok: true;
  body: VersionResponse;
}

export function useGetVersion() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute,
  };

  async function execute() {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl('version'), {
      headers,
    });

    const text = translations.value.actions.fetchVersion;

    const response = await httpClient.action<GetVersionResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = await response.json() as VersionResponse;
        return {
          ok: true,
          body: json
        };
      },
    });

    return response;
  }
}
